import React, { Component, Fragment } from 'react';
import { notify } from 'common/Notification';
import PropTypes from 'prop-types';
import {Alert, Button, ControlLabel, FormGroup, Panel, ProgressBar} from "react-bootstrap";
import SharepointDriveSelector from "../../Integrations/connections/SharepointDriveSelector";
import request from 'superagent';
import SharepointSiteSearch from "../../Integrations/connections/SharepointSiteSearch";
import SharepointFolderSelector from "../../Integrations/connections/SharepointFolderSelector";

export default class SharepointCasefolderSettings extends Component {
  _isMounted = false;

  static defaultProps = {
    connectionId: null,
    casefolderId: null,
  };

  static propTypes = {
    connectionId: PropTypes.number.isRequired,
    casefolderId: PropTypes.number.isRequired,
    onSave: PropTypes.func,
    onLoad: PropTypes.func,
  };

  state = {
    site: null,
    selectedDrive: null,
    error: false,
    folderPath: [],
  };

  async componentDidMount() {
    this._isMounted = true;
    await this.loadCasefolderDrive();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  // avoid state updates on unmounted component warnings
  setStateIfMounted(state) {
    if (this._isMounted)
      this.setState(state);
  }

  loadCasefolderDrive() {
    const { connectionId, casefolderId } = this.props;

    this.setStateIfMounted({ isLoading: true });

    request.get(`/rpc/integrations/connections/${connectionId}/casefolders/${casefolderId}/sharepoint/drive`)
      .then(response => {
        const {
          site,
          drive: selectedDrive,
          folders: folderPath,
        } = response.body;

        this.setStateIfMounted({
          isLoading: false,
          site,
          selectedDrive,
          folderPath: folderPath || [],
        });
      })
      .catch(e => {
        console.error(e.response);
        this.setStateIfMounted({
          isLoading: false,
          error: e.response.status !== 404
        })
      })
    ;
  }

  onSelectSite = (value) => {
    this.setStateIfMounted({site: value});
  }

  onSelectDrive = (value) => {
    let newState = {}

    // if drive is cleared, clear folder path as well
    if (value === null)
      newState.folderPath = [];

    this.setStateIfMounted({selectedDrive: value, ...newState});
  }

  onSelectFolder = (newState) => {
    this.setStateIfMounted({ ...newState });
  }

  onSave = () => {
    const { connectionId, casefolderId } = this.props;
    const { site, selectedDrive, folderPath } = this.state;

    const saveProps = {
      drive_type: 'site',
      site: site,
      drive: selectedDrive,
      folders: folderPath,
    };

    request.post(`/rpc/integrations/connections/${connectionId}/casefolders/${casefolderId}/sharepoint/drive`)
      .send(saveProps)
      .then(() => {
        notify.success("Sharepoint Casefolder Settings Saved");

        if (this.props.onSave)
          this.props.onSave(saveProps);
      })
      .catch(e => {
        console.log("Failed to save sharepoint settings ", e);
        notify.error("Failed to Save SharePoint Casefolder Settings");
      });
  }

  render() {
    const { folderPath, site, selectedDrive } = this.state;

    return (
      <Fragment>
        <Panel>
          <Panel.Heading>
            <Panel.Title componentClass="h3">
              SharePoint Drive Settings
            </Panel.Title>
          </Panel.Heading>
          <Panel.Body>{(() => {
            if (this.state.error) return (
              <Alert bsStyle="danger">
                There was an error loading SharePoint Settings Information.
                If the problem persists, please contact CourtDrive support.
              </Alert>
            );

            if (this.state.isLoading) return (
              <ProgressBar active now={100} />
            );

            return (
              <div>
                <FormGroup>
                  <ControlLabel>Sharepoint Site</ControlLabel>
                  <SharepointSiteSearch
                    connectionId={this.props.connectionId}
                    onSelectSite={this.onSelectSite}
                    defaultValue={site}
                  />
                </FormGroup>

                {site &&
                  <FormGroup>
                    <ControlLabel>Sharepoint Document Library</ControlLabel>
                    <SharepointDriveSelector
                      connectionId={this.props.connectionId}
                      siteId={site.id}
                      defaultValue={this.state.selectedDrive}
                      onSelectDrive={this.onSelectDrive}
                    />
                  </FormGroup>
                }

                {selectedDrive &&
                  <FormGroup>
                    <ControlLabel>Folder</ControlLabel>
                    <SharepointFolderSelector
                      connectionId={this.props.connectionId}
                      selectedDrive={selectedDrive}
                      onSelectFolder={this.onSelectFolder}
                      folderPath={folderPath}
                    />

                  </FormGroup>
                }

                {this.state.selectedDrive &&
                  <div>
                    <Button bsStyle="primary" disabled={!this.state.selectedDrive} onClick={this.onSave}>Save</Button>
                  </div>
                }
              </div>
            );
          })()}
          </Panel.Body>
        </Panel>
      </Fragment>
    );
  }
}


// WEBPACK FOOTER //
// ./src/CaseFolder/Integrations/SharepointCasefolderSettings.jsx